export enum ShutdownReason {
  NightlyReload = 'nightly-reload',
  SwUpdate = 'sw-update',
  Manual = 'manual',
  ChannelSwitch = 'channel-switch',
  WatchdogRestart = 'watchdog-restart',
  Pagehide = 'pagehide',
  MemoryPressure = 'memory-pressure'
}
